import { Popup } from './popup';
export { Popup }; // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default Popup;